// extracted by mini-css-extract-plugin
export default {"Left":"Error403_Left__heoua"};